(function () {
  var dlg = document.getElementById('ltm-welcome');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var KEY = 'ltmw_state';
  var DAY = 86400000;
  var signup = dlg.querySelector('[data-ltmw-signup]');
  var success = dlg.querySelector('[data-ltmw-success]');
  var form = dlg.querySelector('form');
  var errorEl = dlg.querySelector('[data-ltmw-error]');
  var btn = dlg.querySelector('[data-ltmw-submit]');
  var lastFocus = null;

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function blockedPage() { return /^\/(cart|checkout|account|challenge)/.test(location.pathname); }
  function open() {
    if (dlg.open) return;
    lastFocus = document.activeElement;
    dlg.showModal();
    var f = dlg.querySelector('input[type=email]'); if (f && !signup.hidden) f.focus();
  }
  function close() {
    dlg.close();
    var s = read(); if (!s.joined) { s.dismissedAt = Date.now(); write(s); }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  dlg.querySelectorAll('[data-ltmw-close]').forEach(function (b) { b.addEventListener('click', close); });
  dlg.addEventListener('click', function (e) {
    if (e.target !== dlg) return;
    var r = dlg.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
  });
  dlg.addEventListener('cancel', function () { var s = read(); if (!s.joined) { s.dismissedAt = Date.now(); write(s); } });

  function showSuccess() {
    signup.hidden = true; success.hidden = false;
    var s = read(); s.joined = true; write(s);
    var l = success.querySelector('a'); if (l) l.focus();
  }
  function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; btn.disabled = false; btn.textContent = 'Unlock my 10%'; }

  form.addEventListener('submit', function (e) {
    if (!form.checkValidity()) return;
    btn.disabled = true; btn.textContent = 'One moment...';
    var c = form.querySelector('[name=ltmw_consent]'); if (c) c.disabled = true;
  });

  var copy = dlg.querySelector('[data-ltmw-copy]');
  if (copy) copy.addEventListener('click', function () {
    var code = dlg.getAttribute('data-code');
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { copy.textContent = 'Code copied'; });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ltmw-open]');
    if (!t) return;
    e.preventDefault();
    open();
  });

  var posted = location.search.indexOf('customer_posted=true') > -1 && location.hash === '#ltmw-form';
  if (posted) { lastFocus = null; dlg.showModal(); showSuccess(); return; }
  if (!errorEl.hidden) { dlg.showModal(); return; }
  if (blockedPage()) return;
  var s = read();
  if (s.joined) return;
  if (s.dismissedAt && Date.now() - s.dismissedAt < 7 * DAY) return;
  var delay = parseInt(dlg.getAttribute('data-delay') || '5000', 10);
  setTimeout(function () { if (!document.querySelector('dialog[open]')) open(); }, delay);
})();
